import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'
import {ApiBaseUrl} from '../../constants';
import AOS from 'aos';
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';
import { AuthContext } from "./../../context/auth";
import { withSnackbar } from 'react-simple-snackbar';
import {trackPromise} from "react-promise-tracker";

class LoginComponent extends Component {
    static contextType = AuthContext;
    state = {
        loginformdata: {
            phone: '',
            value:''
        }
    }

    componentDidMount(){
        window.scrollTo(0, 0)
        AOS.init();
        document.getElementById('body').className='login-page'
    }

    componentWillUnmount() {
        document.getElementById('body').className=''
    }

    handlePhoneNumber = (status, value, countryData, number, id) => {
        this.setState({
            loginformdata: {
                phone: number,
                value: value
            }
        })
    }

    handleCountryChange = (value, countryData, number) => {
        this.setState({
            loginformdata: {
                phone: number,
                value: value
            }
        })
    }

    handleFormSubmit = (event) => {
        event.preventDefault();
        const phone = this.state.loginformdata.phone.trim();
        //console.log(phone)
        const phone_number = phone.replace('-','').replace(' ','').replace('-','');
        if (this.state.loginformdata.value === '' || phone_number.trim() === '' || phone === '')
            this.props.openSnackbar('Please enter mobile number')
        else {
            const pickDealBody = "phone_number=" + encodeURIComponent(phone_number);
            trackPromise(
            fetch(ApiBaseUrl + "/consumer/send_otp",
                {
                    method: 'POST',
                    body: pickDealBody,
                    headers:
                        {
                            "Content-Type": "application/x-www-form-urlencoded"
                        }
                })
                .then(res => res.json())
                .then(
                    (result) => {
                        if (!result.success && result.data.existing_user) {
                            this.props.history.push({ pathname: process.env.PUBLIC_URL+'/password', state: { phone_number: phone_number }});
                        }
                        else if (!result.success) {
                            this.props.openSnackbar(result.message)
                        }
                        else {
                            this.props.history.push({ pathname: process.env.PUBLIC_URL+'/login-otp', state: { otp: result.data.code, phone_number: phone_number }});
                        }
                    },
                    // Note: it's important to handle errors here
                    // instead of a catch() block so that we don't swallow
                    // exceptions from actual bugs in components.
                    (error) => {
                        this.props.openSnackbar('Oops, something went wrong.')
                    }
                )
            )
        }
    }

    render() {
        return (
            !this.context.authenticated ?
                <div className="login-main">
                    <div className="login-fade mob-gorilla">
                        <div className="login--bgmain"></div>
                    <div className="logo--fadein" data-aos="fade-up" data-aos-delay="100">
                        <img src={`${process.env.PUBLIC_URL}/image/logo_fadein.png`} alt=""/>
                    </div>
                    <div className="choose-deals-outer login--bottom pt-0 mt-0" data-aos="fade-up" data-aos-delay="200">
                        <div className="container">
                            <div className="col-md-8 col-lg-5 mx-auto">
                                <form autoComplete="off" onSubmit={this.handleFormSubmit} className="login-form p-4">
                                    <div className="forgotpswd-outer text-center adjust-xs-login spacing-0">
                                        <h3 className="login-heading mb-0">Welcome to Host4VIP</h3>
                                        <IntlTelInput
                                            fieldName="phone"
                                            inputClassName="form-control forgotpswd__input w-100"
                                            defaultValue={this.state.loginformdata.phone}
                                            onPhoneNumberChange={this.handlePhoneNumber}
                                            onSelectFlag={this.handleCountryChange}
                                            separateDialCode={true}
                                            placeholder="Enter mobile number"
                                            defaultCountry={'us'}
                                            useMobileFullscreenDropdown={false}
                                            preferredCountries={['us']}
                                            onlyCountries={['us', 'gb', 'au']}
                                            ref={input => this.inputElement = input}
                                        />
                                        <div className="btn-rowstack">
                                            <button className="entry-btn cancel-btn grad-on w-xs-100" type="submit">Continue</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            :
            <Redirect to={{ pathname: process.env.PUBLIC_URL+'/', state: { from: this.props.location } }} />
        )
    }
}

export default withSnackbar(LoginComponent,{
    position: 'top-center',
    style: {
        backgroundColor: '#fff',
        color: '#000',
        textAlign: 'center',
        zIndex:999
    },
    closeStyle: {
        color: '#000',
    },
});